import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-lg-4 mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "NG Hantverk", -1)
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "row justify-content-center align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-4 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Jimmy"),
  /*#__PURE__*/_createElementVNode("p", { class: "lead-sm" }, " Jimmy är en hängiven kniventusiast sedan barnsben. Han är passionerad för unika knivmodeller och har en djup förståelse för ergonomi, bladgeometri, stål och hur dessa faktorer påverkar knivbladens prestanda. Jimmy använder alltid en kniv i sitt arbete, vid fiske och under sina ibland extrema vildmarksäventyr. Hans kunskap och erfarenhet gör honom till en pålitlig expert när det kommer till knivars användning i olika sammanhang ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-4 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Micke"),
  /*#__PURE__*/_createElementVNode("p", { class: "lead-sm" }, " Micke är en skicklig verktygsmakare med en gedigen bakgrund som scout och scoutledare i många år. Han är även ordförande i en skytteklubb och hans passion för friluftsliv är uppenbar. Micke är känd för att vara den första personen någonsin som vandrade runt Sverige, vilket visar på hans styrka och uthållighet. Med sin breda erfarenhet och expertis är Micke en pålitlig resurs när det gäller verktyg och utrustning för olika äventyr och aktiviteter i naturen. ")
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import { ref, Ref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AboutUs',
  setup(__props) {

    const isShowing: Ref<boolean> = ref(false);

    function toggle(): void {
        isShowing.value = !isShowing.value;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(" Vid Tabergs fot, i skuggan av drygt 500 års gruvdrift, finner du NG Hantverk. Det är en plats som passar oss perfekt eftersom vi jobbar lika mycket med tradition som med nytänkande. Vi tror att kombinationen av gediget hantverk och toppmoderna material kan ge våra köpare samma glädje som äldre tiders pistolsmeder i Paris när de utropade ”C'est fer de Takaberg!” (Det är järn från Taberg!). Varmt välkommen att upptäcka vad vår smedja kan göra för dig. "),
        _hoisted_4,
        _withDirectives(_createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-outline-secondary mt-3",
          onClick: _withModifiers(toggle, ["prevent"])
        }, "Läs mer", 8, _hoisted_5), [
          [_vShow, !isShowing.value]
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_9, 512), [
      [_vShow, isShowing.value]
    ])
  ], 64))
}
}

})